import moment from 'moment'

export const alertaMixin = {
  methods: {
    exibirAlertaValoresSimples(titulo, valores) {
      let html = ''

      if (typeof valores !== 'undefined' && valores.length) {
        html += '<div style="height: 180px; overflow: auto;">'
        html +=
          '<table class="table table-stripped table-hover table-condensed">'
        html += '<tbody>'

        valores.forEach((v) => {
          html += '<tr>'
          html += '<td>' + v + '</td>'
          html += '</tr>'
        })

        html += '</tbody>'
        html += '</table>'
        html += '</div>'
      } else {
        html = 'Nenhum resultado.'
      }

      this.$alert({
        title: titulo,
        content: html,
        html: true,
        size: 'sm',
      })
    },
    exibirAlertaValores(titulo, valores, atributos, nomes) {
      const getValue = (objeto, path) =>
        path.split('.').reduce((o, k) => (o || {})[k], objeto)

      let html = ''

      if (
        typeof valores !== 'undefined' &&
        valores.length &&
        typeof atributos !== 'undefined' &&
        atributos.length &&
        typeof nomes !== 'undefined' &&
        nomes.length &&
        atributos.length === nomes.length
      ) {
        html += '<div style="height: 300px; overflow: auto;">'
        html +=
          '<table class="table table-stripped table-hover table-condensed">'
        html += '<thead>'
        html += '<tr>'
        nomes.forEach((n) => {
          html += '<th>' + n + '</th>'
        })
        html += '</tr>'
        html += '</thead>'
        html += '<tbody>'

        valores.forEach((v) => {
          if (Array.isArray(v)) {
            v.forEach((d) => {
              html += '<tr>'
              atributos.forEach((a) => {
                let valor = getValue(d, a)

                if (moment(valor, moment.ISO_8601, true).isValid()) {
                  valor = moment(valor).format('DD/MM/YYYY')
                }

                if (valor === 'true' || valor === 'false') {
                  valor = valor === 'true' ? 'Sim' : 'Não'
                }

                if (!valor) {
                  valor = ''
                }

                html += '<td>' + valor + '</td>'
              })
              html += '</tr>'
            })
          } else {
            html += '<tr>'
            atributos.forEach((a) => {
              let valor = getValue(v, a)

              if (moment(valor, moment.ISO_8601, true).isValid()) {
                valor = moment(valor).format('DD/MM/YYYY')
              }

              if (valor === 'true' || valor === 'false') {
                valor = valor === 'true' ? 'Sim' : 'Não'
              }

              if (!valor) {
                valor = ''
              }

              html += '<td>' + valor + '</td>'
            })
            html += '</tr>'
          }
        })

        html += '</tbody>'
        html += '</table>'
        html += '</div>'
      } else {
        html = 'Nenhum resultado.'
      }

      this.$alert({
        title: titulo,
        content: html,
        html: true,
        size: 'lg',
      })
    },
  },
}
